// ERP help metadata (types + static data) shared between AdminHelpTooltips and AdminERPForm.
// Extracted here so both files can import it without triggering Fast Refresh warnings
// (React Fast Refresh requires component files to export only components, not constants).

export interface Step {
  title: string
  content: string
  code?: string
}

export interface ErpHelpEntry {
  erp_type: string
  label: string
  color: string
  textColor: string
  steps: Step[]
  tip?: string
  docUrl?: string
}

export const ERP_META: Omit<ErpHelpEntry, 'steps' | 'tip'>[] = [
  {
    erp_type: 'dolibarr',
    label: 'Dolibarr',
    color: 'bg-teal-100 dark:bg-teal-900/40',
    textColor: 'text-teal-700 dark:text-teal-300',
    docUrl: 'https://wiki.dolibarr.org/index.php/API_REST',
  },
  {
    erp_type: 'odoo',
    label: 'Odoo',
    color: 'bg-purple-100 dark:bg-purple-900/40',
    textColor: 'text-purple-700 dark:text-purple-300',
    docUrl: 'https://www.odoo.com/documentation/17.0/developer/reference/external_api.html',
  },
  {
    erp_type: 'bleez',
    label: 'Bleez',
    color: 'bg-sky-100 dark:bg-sky-900/40',
    textColor: 'text-sky-700 dark:text-sky-300',
    docUrl: 'https://postman.bleez.com',
  },
  {
    erp_type: 'salesforce',
    label: 'Salesforce',
    color: 'bg-blue-100 dark:bg-blue-900/40',
    textColor: 'text-blue-700 dark:text-blue-300',
    docUrl: 'https://developer.salesforce.com/docs/atlas.en-us.api_rest.meta/api_rest/',
  },
  {
    erp_type: 'business_central',
    label: 'Microsoft Business Central',
    color: 'bg-blue-100 dark:bg-blue-900/40',
    textColor: 'text-blue-700 dark:text-blue-300',
    docUrl:
      'https://learn.microsoft.com/fr-fr/dynamics365/business-central/dev-itpro/api-reference/v2.0/',
  },
  {
    erp_type: 'sage100',
    label: 'Sage 100',
    color: 'bg-green-100 dark:bg-green-900/40',
    textColor: 'text-green-700 dark:text-green-300',
  },
  {
    erp_type: 'netsuite',
    label: 'NetSuite (Oracle)',
    color: 'bg-orange-100 dark:bg-orange-900/40',
    textColor: 'text-orange-700 dark:text-orange-300',
    docUrl: 'https://docs.oracle.com/en/cloud/saas/netsuite/ns-online-help/section_4387399416.html',
  },
  {
    erp_type: 'divalto',
    label: 'Divalto Infinity',
    color: 'bg-indigo-100 dark:bg-indigo-900/40',
    textColor: 'text-indigo-700 dark:text-indigo-300',
  },
  {
    erp_type: 'erpnext',
    label: 'ERPNext / Frappe',
    color: 'bg-cyan-100 dark:bg-cyan-900/40',
    textColor: 'text-cyan-700 dark:text-cyan-300',
    docUrl: 'https://frappeframework.com/docs/user/en/api/rest',
  },
  {
    erp_type: 'zoho',
    label: 'Zoho One',
    color: 'bg-red-100 dark:bg-red-900/40',
    textColor: 'text-red-700 dark:text-red-300',
    docUrl: 'https://www.zoho.com/crm/developer/docs/api/v7/',
  },
  {
    erp_type: 'cegid',
    label: 'Cegid XRP Flex',
    color: 'bg-violet-100 dark:bg-violet-900/40',
    textColor: 'text-violet-700 dark:text-violet-300',
  },
]
